import type { CustomReportConfig } from './customReportTypes';
import showcaseReport from './configs/showcaseReport.json';
// import talonLinearReport from './configs/talonLinearReport.json';
// import linearReport from './configs/linearReport.json';
// import dspReport from './configs/dspReport.json';

export const activeCustomReportConfig = showcaseReport as CustomReportConfig;
